$(function(){
    $(".videoblock").each(function() {
        var thisBlock = $(this);
        var altVideoSrc = $(this).data('mfp-src');
        if (altVideoSrc.includes('https://youtu.be')) {
            var newStr = altVideoSrc.split('https://youtu.be/')[1];
            var newYoutubeUrl = 'https://www.youtube.com/watch?v=' + newStr;
            $(this).attr('data-mfp-src', newYoutubeUrl);
        }
        $(this).magnificPopup({
            type: "iframe",
            removalDelay: 160,
            preloader: !1,
            fixedContentPos: !1
        })
    });
});